import { render, staticRenderFns } from "./VehicleTodoList.vue?vue&type=template&id=48f61ce3&scoped=true&"
import script from "./VehicleTodoList.vue?vue&type=script&lang=js&"
export * from "./VehicleTodoList.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTodoList.vue?vue&type=style&index=0&id=48f61ce3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f61ce3",
  null
  
)

export default component.exports